export default {
    zhCN: {
        auth: {
            login: '登录',
            username: '用户名',
            username_placeholder: '请输入用户名',
            password: '密码',
            password_placeholder: '请输入密码',
            code: '验证码',
            code_placeholder: '请输入验证码',
            logout: '注销',
            logout_success: '注销成功',
            day: '天',
            password_expiration: '密码已到期请修改',
            expire: '距离密码到期还剩',
            conseils: '必须包含大写字母、小写字母、数字、特殊符号（{msg}），密码长度在 8-16 位',
        },
        confirm: {
            confirm_deletion: '确认删除?',
            confirm_transfer: 'Confirm Transfer?',
            confirm_void: '确认作废?',
            confirm_release: '确认发布?',
            confirm_reject: '确认拒绝?',
            ack: '确认',
            cancel: '取消',
            confirm: '是否确认？',
            non_records: '请至少选择一条数据',
            pass: '确认提交审核',
            pass_apply: '请确认您要提交上诉申请！(只有 2 次机会）！',
            pass_apply_red: '如上诉时价格条款有误，请在DCS中选择正确的价格条款以完成上诉。',
            pass_apply_red2: '请在上诉前确认!',
            recalculate: '确认重新计算',
            confirm_switch_country: '确认切换国家?',
            batch_submit: '确认批量提交?',
            batch_apply_payment: '确认批量申请支付?',
            confirm_lock: '确认锁定?',
            confirm_unlock: '确认解锁?',
            check: '确认审核?',
            confirm_amount: '确认金额?',
            eu_appeal_confirm:
                '确认申诉提交？提交后，此退款订单将无法修改，也无法重新发起申诉。只有在当前申诉审查完成后，才能重新提交申诉。',
            eu_confirm: '是否确认数据',
        },
        request: {
            failed_placeholder: '请求失败，服务端错误',
            success_placeholder: '请求成功',
            auth: {
                login_success: '登录成功',
            },
            error: {
                '404': '请求路径不存在',
                '403': '权限不足',
            },
        },
    },
    enUS: {
        auth: {
            login: 'Login',
            username: 'Username',
            username_placeholder: 'Enter username',
            password: 'Password',
            password_placeholder: 'Enter password',
            code: 'Verify Code',
            code_placeholder: 'Enter verify code',
            logout: 'Logout',
            logout_success: 'Logout success',
            day: 'Day',
            password_expiration: 'The password has expired, please modify it',
            expire: 'Remaining until password expiration',
            conseils:
                'The password must contain uppercase letters, lowercase letters, numbers, and special characters ({msg}), and the length of the password should be between 8 to 16 characters',
        },
        confirm: {
            confirm_deletion: 'Confirm deletion?',
            confirm_transfer: 'Confirm Transfer?',
            confirm_void: 'Confirm void?',
            confirm_release: 'Confirm release?',
            confirm_reject: 'Confirm Reject?',
            ack: 'Confirm',
            cancel: 'Cancel',
            confirm: 'Do you confirm the reconciliation amount?',
            confirm1: 'Please ensure that the calculation is started!',
            non_records: 'Please choose at least one record',
            pass: 'Confirm submission for review',
            pass_apply:
                'Please confirm that you want to submit an appeal apply! (Only have 2 chances)!',
            pass_apply_red:
                'If appeal with Price Term Error please select the correct Price Term in DCS to get the appealing completed.',
            pass_apply_red2: 'Please make sure you confirm before any appeal!',
            recalculate: 'Confirm Recalculate',
            confirm_switch_country: 'Confirm Switch Company?',
            batch_submit: 'Confirm Batch Submit?',
            batch_apply_payment: 'Confirm Batch Apply Payment?',
            confirm_lock: 'Confirm Lock?',
            confirm_unlock: 'Confirm unLock?',
            check: 'Confirm Check?',
            confirm_amount: 'Confirm the amount?',
            eu_appeal_confirm:
                'Confirm appeal submission? After submission, this rebate order cannot be modified nor the appeal re-initiated. A new appeal may only be filed upon completion of the current appeal review.',
            eu_confirm: 'Are the data confirmed?',
        },
        request: {
            failed_placeholder: 'Request failed, backend error',
            success_placeholder: 'Request success',
            auth: {
                login_success: 'Login success',
            },
            error: {
                '404': 'Request url not found',
                '403': 'Permission denied',
            },
        },
    },
    deDE: {
        auth: {
            login: 'Login',
            username: 'Username',
            username_placeholder: 'Enter username',
            password: 'Password',
            password_placeholder: 'Enter password',
            code: 'Verify Code',
            code_placeholder: 'Enter verify code',
            logout: 'Logout',
            logout_success: 'Logout success',
            day: 'Day',
            password_expiration: 'The password has expired, please modify it',
            expire: 'Remaining until password expiration',
            conseils:
                'The password must contain uppercase letters, lowercase letters, numbers, and special characters ({msg}), and the length of the password should be between 8 to 16 characters',
        },
        confirm: {
            confirm_deletion: 'Confirm deletion?',
            confirm_transfer: 'Confirm Transfer?',
            confirm_void: 'Confirm void?',
            confirm_release: 'Confirm release?',
            confirm_reject: 'Confirm Reject?',
            ack: 'Confirm',
            cancel: 'Cancel',
            confirm: 'Do you confirm the reconciliation amount?',
            confirm1: 'Please ensure that the calculation is started!',
            non_records: 'Please choose at least one record',
            pass: 'Confirm submission for review',
            pass_apply:
                'Please confirm that you want to submit an appeal apply! (Only have 2 chances)!',
            pass_apply_red:
                'If appeal with Price Term Error please select the correct Price Term in DCS to get the appealing completed.',
            pass_apply_red2: 'Please make sure you confirm before any appeal!',
            recalculate: 'Confirm Recalculate',
            confirm_switch_country: 'Confirm Switch Company?',
            batch_submit: 'Confirm Batch Submit?',
            batch_apply_payment: 'Confirm Batch Apply Payment?',
            confirm_lock: 'Confirm Lock?',
            confirm_unlock: 'Confirm unLock?',
            check: 'Confirm Check?',
            confirm_amount: 'Confirm the amount?',
            eu_appeal_confirm:
                'Reklamation einreichen? Nach dem Einreichen kann diese Prämienbestellung nicht mehr geändert und die Reklamation nicht erneut eingereicht werden. Eine neue Reklamation ist erst nach Abschluss der aktuellen Prüfung möglich.',
            eu_confirm: 'Sind die Daten bestätigt?',
        },
        request: {
            failed_placeholder: 'Request failed, backend error',
            success_placeholder: 'Request success',
            auth: {
                login_success: 'Login success',
            },
            error: {
                '404': 'Request url not found',
                '403': 'Permission denied',
            },
        },
    },
};
